/**
 * „Vergleiche mit"-Zielleiste für den Side-by-Side-Modus (C2-B).
 *
 * Toggle-Chips (role=group + aria-pressed, NICHT tablist) zur Auswahl des
 * Vergleichsziels: Master/Produkt oder ein anderer Channel.
 */

import { useTranslation } from 'react-i18next'
import { Star } from 'lucide-react'
import { cn } from '@/lib/utils'

export interface CompareTarget {
  id: string
  name: string
  isMaster?: boolean
}

interface Props {
  targets: CompareTarget[]
  activeId: string
  onChange: (id: string) => void
}

export function CompareTargetBar({ targets, activeId, onChange }: Props) {
  const { t } = useTranslation()
  return (
    <div
      role="group"
      aria-label={t('productContent.channels.compareWith')}
      className="content-compare-target-bar flex items-center gap-2 flex-wrap px-3 py-2 mx-3 mt-2 rounded-lg bg-primary-50 dark:bg-primary-900/20"
    >
      <span className="text-xs font-semibold uppercase tracking-wide text-neutral-500 dark:text-neutral-400 mr-1">
        {t('productContent.channels.compareWith')}
      </span>
      {targets.map((target) => {
        const isActive = target.id === activeId
        return (
          <button
            key={target.id}
            type="button"
            aria-pressed={isActive}
            onClick={() => onChange(target.id)}
            className={cn(
              'inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-sm transition-colors focus:outline-none focus:ring-2 focus:ring-primary-500',
              isActive
                ? 'bg-primary-500 text-white font-semibold'
                : 'bg-white dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-700 text-neutral-700 dark:text-neutral-300 hover:bg-neutral-50 dark:hover:bg-neutral-800',
            )}
          >
            {target.isMaster && <Star className="h-3.5 w-3.5" aria-hidden="true" />}
            {target.name}
          </button>
        )
      })}
    </div>
  )
}
